import React, { useState, useEffect } from 'react';
import "./TypingText.css"
const TypingText = ({ words, typingSpeed = 150, deletingSpeed = 50, delayBetweenWords = 1000 }) => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const currentWord = words[currentWordIndex];

    let timeout;

    if (!isDeleting && displayedText.length < currentWord.length) {
      // Typing
      timeout = setTimeout(() => {
        setDisplayedText(currentWord.slice(0, displayedText.length + 1));
      }, typingSpeed);
    } else if (isDeleting && displayedText.length > 0) {
      // Deleting
      timeout = setTimeout(() => {
        setDisplayedText(currentWord.slice(0, displayedText.length - 1));
      }, deletingSpeed);
    } else if (!isDeleting && displayedText === currentWord) {
      // Wait before deleting
      timeout = setTimeout(() => setIsDeleting(true), delayBetweenWords);
    } else if (isDeleting && displayedText === '') {
      // Move to next word
      timeout = setTimeout(() => {
        setIsDeleting(false);
        setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
      }, 200);
    }

    return () => clearTimeout(timeout);
  }, [displayedText, isDeleting, words, currentWordIndex, typingSpeed, deletingSpeed, delayBetweenWords]);

  return <span className='typingtext'>{displayedText}|</span>;
};

export default TypingText;
